// React Imports
import React, { useContext, useEffect, useState } from "react";

// Package Imports
import { Row, Col } from "react-bootstrap";
import { toJS } from "mobx";
import { observer } from "mobx-react";

// Project Imports
import { TitleTextSubtextRight } from "components";
import FamilyDetailsForm from "./form/index";
import FamilyDetailsFormController from "./form/controller";
import AuthStore from "modules/login/store/AuthStore";
import FormContext from "context/FormContext";
import { sendDataToServer } from "./form/utils";
import formObserver from "./form/observer";
import Observer from "./non-individual-journey-form/observer";
import savePragatiNAInboundData from "utils/savePragatiNAInboundData";

// CSS Imports
import "./components/add-family-member-card.css";
import "./family-details-form.css";
import AddProposerData from "./components/non-individual-journey/AddProposerData";
import EmployeeDetailsFormController from "./non-individual-journey-form/controller";
import EmployeeDetailsForm from "./non-individual-journey-form/index";
import { EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, HUF, INDIVIDUAL, KEYMAN, MWP_ACT, PARTNERSHIP } from "constants/ CustomerType";
import { sendnonIndividualDataToServer } from "./non-individual-journey-form/utils";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../constants/Constants";

const FamilyDetailsPage = ({ errorClass }) => {
  const [formController, setFormController] = useState(undefined);
  const formContext = useContext(FormContext);
  let validJourneyTypes = [EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, HUF, PARTNERSHIP, KEYMAN];

  useEffect(() => {
    if (AuthStore.journeyData !== undefined && formController == undefined) {
      let formController = validJourneyTypes.includes(AuthStore.journeyTypeName) ? new EmployeeDetailsFormController() : new FamilyDetailsFormController();
      
      let journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
      let journeyData = toJS(AuthStore.journeyData);
      let expenseList = toJS(AuthStore.expenseList);
      let lifeCoverList = toJS(AuthStore.lifeCoverList);


      const emiValueCallBack = (expenseName, lastEmiType) => {

        if (expenseName == lastEmiType) {
          formController.$("show_emi_fields").set("value", true)

          if (validJourneyTypes.includes(AuthStore.journeyTypeName)) {
            Observer(formController)
          } else {
            formObserver(formController)
          }
        } else {
          formController.$("show_emi_fields").set("value", false)
        }

      }

      formController.setDefaults(journeyId, journeyData, expenseList, lifeCoverList, emiValueCallBack);
      
      formContext.setFormController(formController);
      if (validJourneyTypes.includes(AuthStore.journeyTypeName)) {
        formContext.setCallbackFunctions({
          success: sendnonIndividualDataToServer,
          error: undefined,
        });
        
      } else {
        formContext.setCallbackFunctions({
          success: sendDataToServer,
          error: undefined,
        });
      }
      setFormController(formController);
    }
    

  }, [AuthStore.journeyData, formController]);



  useEffect(() => {
    savePragatiNAInboundData(location)
  }, []);

  if (formController === undefined) return null;

  return (
    <main className='my-3 family-details-form container'>
      <Row>
        <Col className='col-12 col-md-9'>
          <p className='text-primary font-weight-medium mb-0 mr-1 font-size-18 mt-5 mt-md-0'>Family Profile</p>
          <p className='mb-0 d-md-flex family-details-form-top-text font-size-12 font-weight-light mb-2'>
          Let’s capture your details so that we can recommend the best suited product in the next screen.
          </p>
          <TitleTextSubtextRight title='Family Details' subText='( Mandatory )' />
        </Col>
        {validJourneyTypes.includes(AuthStore.journeyTypeName)
          ?
          <EmployeeDetailsForm formController={formController} errorClass={errorClass} productDetails={AuthStore.journeyData.family_product_details_list} />
          :
          <FamilyDetailsForm formController={formController} errorClass={errorClass} productDetails={AuthStore.journeyData.family_product_details_list} />
        }

      </Row>
    </main>
  );
};

export default observer(FamilyDetailsPage);
